// // import React, { useState, useEffect } from "react";
// // import { useParams, useNavigate } from "react-router-dom";
// // import axios from "axios";
// // import logo from "./Components/Images/zp logo.png";
// // import "./Components/ExamQuestion.css";
// // import useBlockBackNavigation from "../src/hooks/useBlockBackNavigation.js";

// // const API_BASE = process.env.REACT_APP_API_BASE_URL;

// // export default function ExamQuestion({ duration = 2400 }) {
// //   useBlockBackNavigation("You cannot go back during the exam.");
// //   const [exam, setExam] = useState(null);
// //   const [answers, setAnswers] = useState({});
// //   const [loading, setLoading] = useState(true);
// //   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
// //   const [timeLeft, setTimeLeft] = useState(duration);
// //   const [showModal, setShowModal] = useState(false);
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [autoSubmit, setAutoSubmit] = useState(false);
// //   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
// //   const [submittedAttemptId, setSubmittedAttemptId] = useState(null);

// //   const { attemptId } = useParams();
// //   const navigate = useNavigate();

// //   // Fetch exam questions
// //   useEffect(() => {
// //     const fetchExam = async () => {
// //       try {
// //         const res = await axios.get(
// //           `${process.env.REACT_APP_API_BASE_URL}/api/StudentExam/get-questions/${attemptId}`
// //         );
// //         setExam(res.data);

// //         // Save question IDs for review
// //         const questionIds = res.data.questions.map((q) => q.id);
// //         localStorage.setItem("examQuestionIds", JSON.stringify(questionIds));
// //       } catch (err) {
// //         console.error("Failed to load exam:", err);
// //         alert("Could not load exam. Please try again.");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     if (attemptId) fetchExam();
// //   }, [attemptId]);

// //   // Auto-submit if user switches tabs
// //   useEffect(() => {
// //     const handleVisibilityChange = () => {
// //       if (document.hidden) {
// //         alert("You switched tabs! The exam will be submitted automatically.");
// //         handleSubmit(true);
// //       }
// //     };

// //     document.addEventListener("visibilitychange", handleVisibilityChange);
// //     return () => {
// //       document.removeEventListener("visibilitychange", handleVisibilityChange);
// //     };
// //   }, []);

// //   // Timer countdown
// //   useEffect(() => {
// //     const timer = setInterval(() => {
// //       setTimeLeft((prev) => {
// //         if (prev <= 1) {
// //           clearInterval(timer);
// //           handleSubmit(true);
// //           return 0;
// //         }
// //         return prev - 1;
// //       });
// //     }, 1000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   const formatTime = (seconds) => {
// //     const mins = Math.floor(seconds / 60);
// //     const secs = seconds % 60;
// //     return `Time Left: ${mins}m ${secs}s`;
// //   };

// //   const handleAnswer = (questionId, option) => {
// //     setAnswers((prev) => ({
// //       ...prev,
// //       [questionId]: option,
// //     }));
// //   };

// //   const handleSubmit = (auto = false) => {
// //     setShowModal(true);
// //     setAutoSubmit(auto);

// //     // Save student answers to localStorage
// //     localStorage.setItem("studentAnswers", JSON.stringify(answers));

// //     if (auto) {
// //       setTimeout(() => {
// //         submitAnswers();
// //       }, 3000);
// //     }
// //   };

// //   const handleModalSubmit = () => {
// //     setShowModal(false);
// //     submitAnswers();
// //   };

// //   // ✅ Async submit function
// //   const submitAnswers = async () => {
// //     setIsSubmitting(true);

// //     const answerArray = Object.entries(answers).map(([qid, val]) => ({
// //       questionId: parseInt(qid),
// //       selectedAnswer: val,
// //     }));

// //     try {
// //       const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/StudentExam/submit`, {
// //         attemptId,
// //         answers: answerArray,
// //       });

// //       console.log("✅ Submission response:", res.data);
// //       setSubmittedAttemptId(res.data.attemptId || attemptId);
// //       setShowSuccessPopup(true);
// //     } catch (err) {
// //       console.error("Submit error:", err);
// //       alert("Error submitting exam. Please try again.");
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   if (loading)
// //     return <div className="loading-container">Loading exam...</div>;
// //   if (!exam || !exam.questions || exam.questions.length === 0)
// //     return <div className="error-container">No exam questions found.</div>;

// //   const currentQuestion = exam.questions[currentQuestionIndex];
// //   const selectedOption = answers[currentQuestion.id] || null;

// //   return (
// //     <div className="exam-container">
// //       <div className="exam-heading-sec">
// //         <h4 className={`Exam-timer ${timeLeft < 300 ? "time-warning" : ""}`}>
// //           {formatTime(timeLeft)}
// //         </h4>
// //       </div>

// //       <div className="exam-main">
// //         <div className="question-panel">
// //           <div className="question-box">
// //             <div className="question-header">
// //               <div className="question-instruction">
// //                 {/[a-zA-Z]/.test(
// //                   currentQuestion.subQuestion || currentQuestion.questionText
// //                 )
// //                   ? `Q.${currentQuestionIndex + 1}. Read and choose the correct option.`
// //                   : `प्र.${currentQuestionIndex + 1}. पुढील संवाद वाचा व पर्यायातून उत्तर निवडा.`}
// //               </div>
// //               <div className="question-count">
// //                 {currentQuestionIndex + 1}/{exam.questions.length}
// //               </div>
// //             </div>

// //             {currentQuestion.passage && (
// //               <p className="passage">{currentQuestion.passage}</p>
// //             )}

// //             <p className="sub-question">
// //               <strong>
// //                 {currentQuestion.subQuestion || currentQuestion.questionText}
// //               </strong>
// //             </p>

// //             {currentQuestion.questionImageUrl && (
// //               <div className="question-image">
// //                 <img src={currentQuestion.questionImageUrl} alt="Question" />
// //               </div>
// //             )}

// //             {/* Options */}
// //             {["A", "B", "C", "D"].map((letter, idx) => {
// //               const optionText = currentQuestion[`option${letter}`];
// //               const optionImage =
// //                 currentQuestion[`option${letter}ImageUrl`];
// //               const isSelected = selectedOption === letter;
// //               const optionId = `q${currentQuestion.id}_opt${idx + 1}`;
// //               if (!optionText && !optionImage) return null;

// //               return (
// //                 <label
// //                   key={idx}
// //                   htmlFor={optionId}
// //                   className={`circle-option-label ${
// //                     isSelected ? "selected" : ""
// //                   }`}
// //                 >
// //                   <input
// //                     type="radio"
// //                     id={optionId}
// //                     name={`question_${currentQuestion.id}`}
// //                     value={letter}
// //                     checked={isSelected}
// //                     disabled={isSubmitting || timeLeft <= 0}
// //                     onChange={() => handleAnswer(currentQuestion.id, letter)}
// //                   />
// //                   <span className="custom-radio" />
// //                   <span className="option-text">
// //                     {optionText && `${letter}) ${optionText}`}
// //                     {optionImage && (
// //                       <img
// //                         src={optionImage}
// //                         alt={`Option ${letter}`}
// //                         className="option-image"
// //                       />
// //                     )}
// //                   </span>
// //                 </label>
// //               );
// //             })}

// //             <div className="navigation-buttons">
// //               <button
// //                 className="nav-btnPreview"
// //                 onClick={() =>
// //                   setCurrentQuestionIndex((prev) => Math.max(prev - 1, 0))
// //                 }
// //                 disabled={currentQuestionIndex === 0 || isSubmitting}
// //               >
// //                 ❮ Previous
// //               </button>

// //               {currentQuestionIndex < exam.questions.length - 1 ? (
// //                 <button
// //                   className="nav-btnOne"
// //                   onClick={() =>
// //                     setCurrentQuestionIndex((prev) => prev + 1)
// //                   }
// //                   disabled={!selectedOption || isSubmitting}
// //                 >
// //                   Next ❯❯
// //                 </button>
// //               ) : (
// //                 <button
// //                   className="submit-btn"
// //                   onClick={() => handleSubmit()}
// //                   disabled={isSubmitting}
// //                 >
// //                   {isSubmitting ? "Submitting..." : "End Test"}
// //                 </button>
// //               )}
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Modal */}
// //       {showModal && (
// //         <div className="modal-overlay">
// //           <div className="modal-box">
// //             {!autoSubmit && (
// //               <button
// //                 className="close-modal"
// //                 onClick={() => setShowModal(false)}
// //                 disabled={isSubmitting}
// //               >
// //                 ×
// //               </button>
// //             )}
// //             <h3>{autoSubmit ? "Time's up!" : "Are you sure?"}</h3>
// //             <p>
// //               {autoSubmit
// //                 ? "आपला वेळ संपला आहे. चाचणी आपोआप सबमिट होत आहे..."
// //                 : "You want to submit your test?"}
// //             </p>
// //             <div className="modal-actions">
// //               {!autoSubmit && (
// //                 <button
// //                   className="modal-cancel"
// //                   onClick={() => setShowModal(false)}
// //                   disabled={isSubmitting}
// //                 >
// //                   Cancel
// //                 </button>
// //               )}
// //               <button
// //                 className="modal-submit"
// //                 onClick={handleModalSubmit}
// //                 disabled={isSubmitting}
// //               >
// //                 {isSubmitting ? "Submitting..." : "Submit"}
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* Success Popup */}
// //       {showSuccessPopup && (
// //         <div className="success-popup-overlay">
// //           <div className="success-popup">
// //             <img src={logo} alt="ZP Logo" className="popup-logo" />
// //             <h3>✅ Test Submitted Successfully!</h3>
// //             <p>Your answers have been saved.</p>
// //             <button
// //               className="popup-ok-btn"
// //               onClick={() =>
// //                 navigate(`/test-review/${submittedAttemptId || attemptId}`)
// //               }
// //             >
// //               OK
// //             </button>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }




// // Auto-submit and timer will now submit the latest answers
// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import logo from "./Components/Images/zp logo.png";
// import "./Components/ExamQuestion.css";
// import useBlockBackNavigation from "../src/hooks/useBlockBackNavigation.js";

// const API_BASE = process.env.REACT_APP_API_BASE_URL;

// export default function ExamQuestion({ duration = 2400 }) {
//   useBlockBackNavigation("You cannot go back during the exam.");
//   const [exam, setExam] = useState(null);
//   const [answers, setAnswers] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
//   const [timeLeft, setTimeLeft] = useState(duration);
//   const [showModal, setShowModal] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [autoSubmit, setAutoSubmit] = useState(false);
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [submittedAttemptId, setSubmittedAttemptId] = useState(null);

//   const { attemptId } = useParams();
//   const navigate = useNavigate();

//   // Fetch exam questions
//   useEffect(() => {
//     const fetchExam = async () => {
//       try {
//         const res = await axios.get(
//           `${API_BASE}/api/StudentExam/get-questions/${attemptId}`
//         );
//         setExam(res.data);

//         // Save question IDs for review
//         const questionIds = res.data.questions.map((q) => q.id);
//         localStorage.setItem("examQuestionIds", JSON.stringify(questionIds));
//       } catch (err) {
//         console.error("Failed to load exam:", err);
//         alert("Could not load exam. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     if (attemptId) fetchExam();
//   }, [attemptId]);

//   // Auto-submit if user switches tabs
//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (document.hidden) {
//         alert("You switched tabs! The exam will be submitted automatically.");
//         submitAnswers(answers, true); // submit immediately with latest answers
//       }
//     };

//     document.addEventListener("visibilitychange", handleVisibilityChange);
//     return () => {
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//     };
//   }, [answers]);

//   // Timer countdown
//   useEffect(() => {
//     const timer = setInterval(() => {
//       setTimeLeft((prev) => {
//         if (prev <= 1) {
//           clearInterval(timer);
//           submitAnswers(answers, true); // auto-submit on timer expiry
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);
//     return () => clearInterval(timer);
//   }, [answers]);

//   const formatTime = (seconds) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `Time Left: ${mins}m ${secs}s`;
//   };

//   const handleAnswer = (questionId, option) => {
//     setAnswers((prev) => ({
//       ...prev,
//       [questionId]: option,
//     }));
//   };

//   const handleSubmit = (auto = false) => {
//     setShowModal(true);
//     setAutoSubmit(auto);

//     if (!auto) return; // manual submit waits for modal
//     // Auto-submit immediately
//     submitAnswers(answers, true);
//   };

//   const handleModalSubmit = () => {
//     setShowModal(false);
//     submitAnswers(answers, false); // manual submit
//   };

//   // ✅ Async submit function
//   const submitAnswers = async (currentAnswers = answers, isAuto = false) => {
//     if (isSubmitting) return; // prevent double submission
//     setIsSubmitting(true);

//     const answerArray = Object.entries(currentAnswers).map(([qid, val]) => ({
//       questionId: parseInt(qid),
//       selectedAnswer: val,
//     }));

//     try {
//       const res = await axios.post(`${API_BASE}/api/StudentExam/submit`, {
//         attemptId,
//         answers: answerArray,
//       });

//       setSubmittedAttemptId(res.data.attemptId || attemptId);
//       setShowSuccessPopup(true);
//       setShowModal(false);
//     } catch (err) {
//       console.error("Submit error:", err);
//       alert("Error submitting exam. Please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (loading) return <div className="loading-container">Loading exam...</div>;
//   if (!exam || !exam.questions || exam.questions.length === 0)
//     return <div className="error-container">No exam questions found.</div>;

//   const currentQuestion = exam.questions[currentQuestionIndex];
//   const selectedOption = answers[currentQuestion.id] || null;

//   return (
//     <div className="exam-container">
//       <div className="exam-heading-sec">
//         <h4 className={`Exam-timer ${timeLeft < 300 ? "time-warning" : ""}`}>
//           {formatTime(timeLeft)}
//         </h4>
//       </div>

//       <div className="exam-main">
//         <div className="question-panel">
//           <div className="question-box">
//             <div className="question-header">
//               <div className="question-instruction">
//                 {/[a-zA-Z]/.test(
//                   currentQuestion.subQuestion || currentQuestion.questionText
//                 )
//                   // ? `Q.${currentQuestionIndex + 1}. Read and choose the correct option.`
//                   // : `प्र.${currentQuestionIndex + 1}. पुढील संवाद वाचा व पर्यायातून उत्तर निवडा.`
//                 }
//               </div>
//               <div className="question-count">
//                 {currentQuestionIndex + 1}/{exam.questions.length}
//               </div>
//             </div>

//             {currentQuestion.passage && (
//               <p className="passage">{currentQuestion.passage}</p>
//             )}

//             <p className="sub-question">
//               <strong
//                 dangerouslySetInnerHTML={{
//                   __html: currentQuestion.subQuestion || currentQuestion.questionText,
//                 }}
//               />
//             </p>

//             {currentQuestion.questionImageUrl && (
//               <div className="question-image">
//                 <img src={currentQuestion.questionImageUrl} alt="Question" />
//               </div>
//             )}

//             {/* Options */}
//             {["A", "B", "C", "D"].map((letter, idx) => {
//               const optionText = currentQuestion[`option${letter}`];
//               const optionImage =
//                 currentQuestion[`option${letter}ImageUrl`];
//               const isSelected = selectedOption === letter;
//               const optionId = `q${currentQuestion.id}_opt${idx + 1}`;
//               if (!optionText && !optionImage) return null;

//               return (
//                 <label
//                   key={idx}
//                   htmlFor={optionId}
//                   className={`circle-option-label ${isSelected ? "selected" : ""
//                     }`}
//                 >
//                   <input
//                     type="radio"
//                     id={optionId}
//                     name={`question_${currentQuestion.id}`}
//                     value={letter}
//                     checked={isSelected}
//                     disabled={isSubmitting || timeLeft <= 0}
//                     onChange={() => handleAnswer(currentQuestion.id, letter)}
//                   />
//                   <span className="custom-radio" />
//                   <span className="option-text">
//                     {optionText && `${letter}) ${optionText}`}
//                     {optionImage && (
//                       <img
//                         src={optionImage}
//                         alt={`Option ${letter}`}
//                         className="option-image"
//                       />
//                     )}
//                   </span>
//                 </label>
//               );
//             })}

//             <div className="navigation-buttons">
//               <button
//                 className="nav-btnPreview"
//                 onClick={() =>
//                   setCurrentQuestionIndex((prev) => Math.max(prev - 1, 0))
//                 }
//                 disabled={currentQuestionIndex === 0 || isSubmitting}
//               >
//                 ❮ Previous
//               </button>

//               {currentQuestionIndex < exam.questions.length - 1 ? (
//                 <button
//                   className="nav-btnOne"
//                   onClick={() =>
//                     setCurrentQuestionIndex((prev) => prev + 1)
//                   }
//                   disabled={!selectedOption || isSubmitting}
//                 >
//                   Next ❯❯
//                 </button>
//               ) : (
//                 <button
//                   className="submit-btn"
//                   onClick={() => handleSubmit()}
//                   disabled={isSubmitting}
//                 >
//                   {isSubmitting ? "Submitting..." : "End Test"}
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Modal */}
//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-box">
//             {!autoSubmit && (
//               <button
//                 className="close-modal"
//                 onClick={() => setShowModal(false)}
//                 disabled={isSubmitting}
//               >
//                 ×
//               </button>
//             )}
//             <h3>{autoSubmit ? "Time's up!" : "Are you sure?"}</h3>
//             <p>
//               {autoSubmit
//                 ? "आपला वेळ संपला आहे. चाचणी आपोआप सबमिट होत आहे..."
//                 : "You want to submit your test?"}
//             </p>
//             <div className="modal-actions">
//               {!autoSubmit && (
//                 <button
//                   className="modal-cancel"
//                   onClick={() => setShowModal(false)}
//                   disabled={isSubmitting}
//                 >
//                   Cancel
//                 </button>
//               )}
//               <button
//                 className="modal-submit"
//                 onClick={handleModalSubmit}
//                 disabled={isSubmitting}
//               >
//                 {isSubmitting ? "Submitting..." : "Submit"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Success Popup */}
//       {showSuccessPopup && (
//         <div className="success-popup-overlay">
//           <div className="success-popup">
//             <img src={logo} alt="ZP Logo" className="popup-logo" />
//             <h3>✅ Test Submitted Successfully!</h3>
//             <p>Your answers have been saved.</p>
//             <button
//               className="popup-ok-btn"
//               onClick={() =>
//                 navigate(`/test-review/${submittedAttemptId || attemptId}`)
//               }
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }










// Auto-submit and timer will now submit the latest answers
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "./Components/Images/zp logo.png";
import "./Components/ExamQuestion.css";
import useBlockBackNavigation from "../src/hooks/useBlockBackNavigation.js";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function ExamQuestion({ duration = 2400 }) {
  useBlockBackNavigation("You cannot go back during the exam.");
  const [exam, setExam] = useState(null);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(duration);
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [autoSubmit, setAutoSubmit] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [submittedAttemptId, setSubmittedAttemptId] = useState(null);

  const { attemptId } = useParams();
  const navigate = useNavigate();

  // Fetch exam questions
  useEffect(() => {
    const fetchExam = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/StudentExam/get-questions/${attemptId}`
        );
        setExam(res.data);

        // Save question IDs for review
        const questionIds = res.data.questions.map((q) => q.id);
        localStorage.setItem("examQuestionIds", JSON.stringify(questionIds));
      } catch (err) {
        console.error("Failed to load exam:", err);
        alert("Could not load exam. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    if (attemptId) fetchExam();
  }, [attemptId]);
 
  // Timer countdown
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          submitAnswers(answers, true); // auto-submit on timer expiry
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [answers]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `Time Left: ${mins}m ${secs}s`;
  };

  const handleAnswer = (questionId, option) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: option,
    }));
  };

  const handleSubmit = (auto = false) => {
    setShowModal(true);
    setAutoSubmit(auto);

    if (!auto) return; // manual submit waits for modal
    // Auto-submit immediately
    submitAnswers(answers, true);
  };

  const handleModalSubmit = () => {
    setShowModal(false);
    submitAnswers(answers, false); // manual submit
  };

  // ✅ Async submit function
  const submitAnswers = async (currentAnswers = answers, isAuto = false) => {
    if (isSubmitting) return; // prevent double submission
    setIsSubmitting(true);

    const answerArray = Object.entries(currentAnswers).map(([qid, val]) => ({
      questionId: parseInt(qid),
      selectedAnswer: val,
    }));

    try {
      const res = await axios.post(`${API_BASE}/api/StudentExam/submit`, {
        attemptId,
        answers: answerArray,
      });

      setSubmittedAttemptId(res.data.attemptId || attemptId);
      setShowSuccessPopup(true);
      setShowModal(false);
    } catch (err) {
      console.error("Submit error:", err);
      alert("Error submitting exam. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) return <div className="loading-container">Loading exam...</div>;
  if (!exam || !exam.questions || exam.questions.length === 0)
    return <div className="error-container">No exam questions found.</div>;

  const currentQuestion = exam.questions[currentQuestionIndex];
  const selectedOption = answers[currentQuestion.id] || null;

  return (
    <div className="exam-container">
      <div className="exam-heading-sec">
        <h4 className={`Exam-timer ${timeLeft < 300 ? "time-warning" : ""}`}>
          {formatTime(timeLeft)}
        </h4>
      </div>

      <div className="exam-main">
        <div className="question-panel">
          <div className="question-box">
            <div className="question-header">
              <div className="question-instruction">
                {/[a-zA-Z]/.test(
                  currentQuestion.subQuestion || currentQuestion.questionText
                )
                  // ? `Q.${currentQuestionIndex + 1}. Read and choose the correct option.`
                  // : `प्र.${currentQuestionIndex + 1}. पुढील संवाद वाचा व पर्यायातून उत्तर निवडा.`
                }
              </div>
              <div className="question-count">
                {currentQuestionIndex + 1}/{exam.questions.length}
              </div>
            </div>

            {currentQuestion.passage && (
              <p className="passage">{currentQuestion.passage}</p>
            )}

            <p className="sub-question">
              <strong
                dangerouslySetInnerHTML={{
                  __html: currentQuestion.subQuestion || currentQuestion.questionText,
                }}
              />
            </p>

            {currentQuestion.questionImageUrl && (
              <div className="question-image">
                <img src={currentQuestion.questionImageUrl} alt="Question" />
              </div>
            )}

            {/* Options */}
            {["A", "B", "C", "D"].map((letter, idx) => {
              const optionText = currentQuestion[`option${letter}`];
              const optionImage =
                currentQuestion[`option${letter}ImageUrl`];
              const isSelected = selectedOption === letter;
              const optionId = `q${currentQuestion.id}_opt${idx + 1}`;
              if (!optionText && !optionImage) return null;

              return (
                <label
                  key={idx}
                  htmlFor={optionId}
                  className={`circle-option-label ${isSelected ? "selected" : ""
                    }`}
                >
                  <input
                    type="radio"
                    id={optionId}
                    name={`question_${currentQuestion.id}`}
                    value={letter}
                    checked={isSelected}
                    disabled={isSubmitting || timeLeft <= 0}
                    onChange={() => handleAnswer(currentQuestion.id, letter)}
                  />
                  <span className="custom-radio" />
                  <span className="option-text">
                    {optionText && `${letter}) ${optionText}`}
                    {optionImage && (
                      <img
                        src={optionImage}
                        alt={`Option ${letter}`}
                        className="option-image"
                      />
                    )}
                  </span>
                </label>
              );
            })}

            <div className="navigation-buttons">
              <button
                className="nav-btnPreview"
                onClick={() =>
                  setCurrentQuestionIndex((prev) => Math.max(prev - 1, 0))
                }
                disabled={currentQuestionIndex === 0 || isSubmitting}
              >
                ❮ Previous
              </button>

              {currentQuestionIndex < exam.questions.length - 1 ? (
                <button
                  className="nav-btnOne"
                  onClick={() =>
                    setCurrentQuestionIndex((prev) => prev + 1)
                  }
                  disabled={!selectedOption || isSubmitting}
                >
                  Next ❯❯
                </button>
              ) : (
                <button
                  className="submit-btn"
                  onClick={() => handleSubmit()}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "End Test"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            {!autoSubmit && (
              <button
                className="close-modal"
                onClick={() => setShowModal(false)}
                disabled={isSubmitting}
              >
                ×
              </button>
            )}
            <h3>{autoSubmit ? "Time's up!" : "Are you sure?"}</h3>
            <p>
              {autoSubmit
                ? "आपला वेळ संपला आहे. चाचणी आपोआप सबमिट होत आहे..."
                : "You want to submit your test?"}
            </p>
            <div className="modal-actions">
              {!autoSubmit && (
                <button
                  className="modal-cancel"
                  onClick={() => setShowModal(false)}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
              )}
              <button
                className="modal-submit"
                onClick={handleModalSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Popup */}
      {showSuccessPopup && (
        <div className="success-popup-overlay">
          <div className="success-popup">
            <img src={logo} alt="ZP Logo" className="popup-logo" />
            <h3>✅ Test Submitted Successfully!</h3>
            <p>Your answers have been saved.</p>
            <button
              className="popup-ok-btn"
              onClick={() =>
                navigate(`/test-review/${submittedAttemptId || attemptId}`)
              }
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}